import { DeviceType } from "core/features/device/enums/device-type.enum";
import { BehaviorSubject, Subject } from "rxjs";

class DeviceService {
    private static MOBILE_DEVICE_WIDTH: number = 767.98;
    private static TABLET_DEVICE_WIDTH: number = 991.98;

    private _window: JQuery<Window>;

    private _deviceType: BehaviorSubject<DeviceType>;

    public get deviceType(): Subject<DeviceType> {
        return this._deviceType;
    }

    public checkDeviceType(): DeviceType {
        if ($(window).get(0).matchMedia(`(max-width: ${DeviceService.MOBILE_DEVICE_WIDTH}px)`).matches) {
            return DeviceType.Mobile;
        } else if ($(window).get(0).matchMedia(`(max-width: ${DeviceService.TABLET_DEVICE_WIDTH}px)`).matches) {
            return DeviceType.Tablet;
        } else {
            return DeviceType.Desktop;
        }
    }

    private handleResize(): void {
        this._deviceType.next(this.checkDeviceType());
    }

    private bindEvents(): void {
        this._window.on("orientationchange resize", () => this.handleResize());
    }

    private initContext(): void {
        this._window = $(window);

        this._deviceType = new BehaviorSubject(this.checkDeviceType());
    }

    public init(): void {
        this.initContext();
        this.bindEvents();
    }
}

export const deviceService = new DeviceService();
